import React from 'react';
import { Grid } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Content from 'components/Content';
import { BackButton } from 'components/Buttons';

const UnderConstruction = () => {
	return (
		<Content>
			<Grid
				container
				direction="row"
				justifyContent="space-between"
				alignItems="flex-start"
			>
				<BackButton />
			</Grid>
			<h1>Page is Under Construction</h1>
			<h1 style={{ fontSize: '7rem', color: 'orange' }}>
				<FontAwesomeIcon icon="tools" />
			</h1>

			<h3>Page is planned but net yet finished</h3>
			<h3>Please check again later</h3>
		</Content>
	);
};

export default UnderConstruction;
